export enum EmployeeStatus {
    Deleted = 0,      // Renamed from Inactive - represents deleted employees
    Active = 1,
    Inactive = 2      // NEW - represents temporarily inactive employees
}